import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import Cookies from 'js-cookie';
import { useEffect, useRef, useState } from 'react';
import useAuthentication from '../../hooks/useAuthentication';
import * as LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';
import { optIntoTracking, optOutOfTracking } from './LogRocketApi';
import { getEnvVariable } from '../../utils/envUtils';
/**
 *  GDPR Preferences check
 *  accepts a given gdprPrefs cookie or looks it up itself
 *  0 is reqired cookies only
 *  1 is functional cookies (this is what's necessary to track)
 *  2 is advertising cookies
 *
 * @returns boolean
 */
export var isUserTrackable = function (gdprPrefs) {
  switch (gdprPrefs) {
    case '0:':
    case '0,2:':
      return false;
    case '0,1:':
    case '0,1,2:':
      return true;
    default:
      //No cookie
      return false;
  }
};
export var LogRocketContext = /*#__PURE__*/React.createContext({
  initLogRocketSession: function () {},
  handleCookieChange: function () {}
});
/**
 *  LogRocket Provider for DPP
 *  Handles initialization of Logrocket and management of GDPR/CCPA privacy settings
 *  checks for GDPR/CCPA cookie and calls log rocket api to opt in or out of tracking based on the value of the cookie
 *
 *  opting out will delete all records we have under that user, opting in will remove the user
 *  from the 'do-not-track' array they have stored.
 *
 *  Connects to (and dependent on) the CookieConsent script, which inserts/updates the teconsent div on the app's page
 *
 *  exposes the init function and handleCookieChange, to allow for other parts of the app to re-trigger the init call if necessary
 *
 * @returns nothing - render this somewhere under the auth0Provider and it'll do it's thing
 */
var LogRocketProvider = function (_a) {
  var children = _a.children;
  var user = useAuthentication().user;
  // NOTE: component needs refs to let observer see updated value (stale closure issue otherwise)
  var logRocketInitialized = useRef(false);
  var _b = useState(false),
    optedOut = _b[0],
    setOptedOut = _b[1];
  var cookieRef = useRef(Cookies.get('notice_gdpr_prefs') || '');
  var userRef = useRef(user);
  /** keeps the user ref up to date,
   * makes sure as soon as the user loads we update their prefs
   */
  useEffect(function () {
    userRef.current = user;
    checkAndUpdateUserPrefs(cookieRef.current);
  }, [user]);
  /**
   * Run initial logrocket init,
   */
  useEffect(function () {
    initLogRocketSession();
  }, []);
  /**
   *  Handles acting on a change to the notice_gdpr_prefs cookie
   *  called when the observer notices a change to the teconsent div (useEffect above)
   *  triggers an update to preferences if the users cookie changed
   */
  var handleCookieChange = function () {
    var newCookieValue = Cookies.get('notice_gdpr_prefs') || '';
    // console.log('CHANGE HANDLER: old cookie is:', cookieRef.current);
    // console.log('CHANGE HANDLER: new cookie is:', newCookieValue);
    if (newCookieValue !== cookieRef.current) {
      // console.log('CHANGE HANDLER: cookie change detected!');      
      cookieRef.current = newCookieValue;
      checkAndUpdateUserPrefs(newCookieValue);
    }
  };
  /** GDPR/CCPA privacy check
   * Checks the value of the passed in cookie and calls the correct logrocket api to opt the user in or out of tracking
   * if it detects trackign is being turned on, calls the LogRocketProvider to start a new session
   * @param gdprPrefs string value of the notice_gdpr_prefs cookie
   */
  var checkAndUpdateUserPrefs = function (gdprPrefs) {
    return __awaiter(void 0, void 0, void 0, function () {
      var _a, _b, _c;
      return __generator(this, function (_d) {
        switch (_d.label) {
          case 0:
            if (!((_a = userRef.current) === null || _a === void 0 ? void 0 : _a.email)) return [3 /*break*/, 4];
            if (!isUserTrackable(gdprPrefs)) return [3 /*break*/, 2];
            setOptedOut(false); // reset opt out value
            return [4 /*yield*/, optIntoTracking((_b = userRef.current) === null || _b === void 0 ? void 0 : _b.email)];
          case 1:
            _d.sent();
            initLogRocketSession();
            return [3 /*break*/, 4];
          case 2:
            if (!!optedOut) return [3 /*break*/, 4];
            setOptedOut(true);
            return [4 /*yield*/, optOutOfTracking((_c = userRef.current) === null || _c === void 0 ? void 0 : _c.email)];
          case 3:
            _d.sent();
            return [3 /*break*/, 4];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  };
  /**
   * Logrocket Initialization
   * GDPR Requirement ***
   * Logrocket must abide by the notice_gdpr_prefs cookie, and not initialize if it's set to disallow tracking
   */
  var initLogRocketSession = function () {
    var gdprPrefs = Cookies.get('notice_gdpr_prefs') || '';
    // console.log('LOGROCKET INIT TIME: ', gdprPrefs, logRocketInitialized);
    var LOGROCKET_APP_ID = getEnvVariable('LOGROCKET_APP_ID');
    var canTrack = isUserTrackable(gdprPrefs);
    if (LOGROCKET_APP_ID && !logRocketInitialized.current && canTrack) {
      // console.log('LOGROCKET actually is starting up now....');
      LogRocket.init(LOGROCKET_APP_ID, {
        browser: {
          urlSanitizer: function (url) {
            var sanitizedUrl = url;
            sanitizedUrl = sanitizedUrl.replace(/access_token=([^&]*)/, 'access_token=**redacted**');
            return sanitizedUrl;
          }
        },
        dom: {
          textSanitizer: true,
          inputSanitizer: true
        },
        network: {
          requestSanitizer: function (request) {
            request.body = undefined;
            if (request.headers['Authorization']) {
              request.headers['Authorization'] = '******';
            }
            if (request.headers['authorization']) {
              request.headers['authorization'] = '******';
            }
            return request;
          },
          responseSanitizer: function (response) {
            response.body = undefined;
            return response;
          }
        }
      });
      setupLogRocketReact(LogRocket);
      LogRocket.getSessionURL(function (sessionURL) {
        // @ts-ignore
        newrelic.setCustomAttribute('logrocket_url', sessionURL);
        // @ts-ignore
        window.logRocket = {
          sessionURL: sessionURL
        };
      });
      // console.log('LOGROCKET startup complete!');
    }
  };
  return _jsx(LogRocketContext.Provider, __assign({
    value: {
      initLogRocketSession: initLogRocketSession,
      handleCookieChange: handleCookieChange
    }
  }, {
    children: children
  }));
};
export default LogRocketProvider;